module.exports = __webpack_public_path__ + "adce8570922b8590281b9a053023182a.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/termine/brennholzverleih.jpg
// module id = 728
// module chunks = 0